import equal from "fast-deep-equal";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { ExclusivityConflictShowList, ScheduleConflictShowList } from "./ConflictingShowsList";
import { ExclusivityCheckFields, ExclusivityCheckResult, fetchExclusivityConflicts } from "./utils";
import { CustomSidePanel } from "components/SidePanel/CustomSidePanel";
import { SidePanelRef } from "components/SidePanel/SidePanel";

interface Props {
  exclusivityCheckFields: ExclusivityCheckFields
}

export const ExclusivitySidePanel = (props: Props) => {
  const sidePanelRef = useRef<SidePanelRef>();
  const [exclusivityCheckFields, setExclusivityCheckFields] = useState(props.exclusivityCheckFields);
  const [result, setResult] = useState<ExclusivityCheckResult>({
    exclusivityCheckProblems: [],
    scheduleConflictProblems: [],
    exclusivityConflicts: [],
    scheduleConflicts: [],
  });

  // A slightly complex pair of use effects. This makes sure a refetch is only tirggered when the value of any of the fields changes
  useEffect(() => {
    const fetchConflicts = async () => {
      const exclusivityConflictResult = await fetchExclusivityConflicts(exclusivityCheckFields, site.userPreference.display.displayScheduleConflicts, result);
      setResult(exclusivityConflictResult);
      if (exclusivityConflictResult.exclusivityConflicts.length > 0 || exclusivityConflictResult.scheduleConflicts.length > 0) {
        sidePanelRef.current.open();
      }
    }
    fetchConflicts();
  }, [exclusivityCheckFields])

  useEffect(() => {
    if (!equal(props.exclusivityCheckFields, exclusivityCheckFields)) {
      setExclusivityCheckFields(props.exclusivityCheckFields);
    }
  }, [props.exclusivityCheckFields]);

  return <CustomSidePanel
    ref={sidePanelRef}
    trigger={null}
    id="exclusivity-check"
    size="medium"
    title={RESX.Exclusivity.resxConflicts}
  >
    <ExclusivityConflictShowList
      conflictingShows={result.exclusivityConflicts}
      startDisplay={moment.utc(exclusivityCheckFields.showStartDisplay)}
      noConflictsLabel={RESX.Exclusivity.NoConflicts}
      problems={result.exclusivityCheckProblems}
    />

    {site.userPreference.display.displayScheduleConflicts && <ScheduleConflictShowList
      conflictingShows={result.scheduleConflicts}
      startDisplay={moment.utc(exclusivityCheckFields.showStartDisplay)}
      noConflictsLabel={RESX.Exclusivity.NoScheduleConflicts}
      problems={result.scheduleConflictProblems}
    />}
  </CustomSidePanel>
}